<!-- header config -->
<div *ngIf="expansionStyle == 'header'">
    <div class="row">
        <div class="col col-sm-12"><div class="c-title--subsection ">Header Label</div></div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="headerLabel">Label</label></div>
                <input id="headerLabel"
                    cclFormInput
                    type="text"
                    class="c-form-group__input c-input--required"
                    [(ngModel)]="headerConfig.label"
                    maxlength="100"
                />
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="headerLabelColor">Label Color</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="headerConfig.label_color"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="headerLabelColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="headerConfig.label_color"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': headerConfig.label_color }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="headerBackgroundColor">Background Color</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="headerConfig.background"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="headerBackgroundColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="headerConfig.background"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': headerConfig.background }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="fontStyle">Font Style</label></div>
                <ccl-simple-select formId="fontStyle"
                    [listOfItems]="sharedService.fontStyles"
                    (valueChange)="headerConfig.fontStyle = $event.value"
                    [value]="headerConfig.fontStyle"
                    [bindValue]="'id'"
                    [bindLabel]="'label'"
                    [isClearable]="false"
                ></ccl-simple-select>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>
</div>

<!-- button config -->
<div *ngIf="expansionStyle == 'button'">
    <div class="row">
        <div class="col col-sm-12"><div class="c-title--subsection ">Primary</div></div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="buttonBackground">Background</label></div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.primary.background"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                >
                    <input id="buttonBackground"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.primary.background"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.primary.background }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="buttonFontColor">Font Color</label></div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.primary.color"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="buttonFontColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.primary.color"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.primary.color }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>

    <!-- <div class="row">
        <div class="col col-sm-12"><div class="c-title--subsection ">Secondary</div></div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="button2Background">Background</label></div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.secondary.background"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                >
                    <input id="button2Background"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.secondary.background"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.secondary.background }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="button2FontColor">Font Color</label></div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.secondary.color"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="button2FontColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.secondary.color"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.secondary.color }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div> -->
</div>
